import script from "./RetainedProfits.vue?vue&type=script&setup=true&lang=js"
export * from "./RetainedProfits.vue?vue&type=script&setup=true&lang=js"

import "./RetainedProfits.vue?vue&type=style&index=0&id=2c984527&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c984527"]])

export default __exports__